// @flow
import { observable } from 'mobx';

export default class PageResult<T> {
  @observable data: Array<T> = [];
  @observable current_page: number = 0;
  @observable from: number = 1;
  @observable  last_page: number = 0;
  @observable per_page: number = 0;
  @observable to: number = 0;
  @observable total: number = 0;
  
  constructor(data?: any) {
    if(data) {
      Object.assign(this, data);
      this.data = data.data || [];
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/Model/PageResult.js